import React from "react"
import {Row, Col} from "@irati/ui/src/Layout"

import withBranding, {WithBranding} from "@irati/brand/withBranding"

import {MainSection, MainSectionImage} from "./styled"

interface Props extends WithBranding {
  children: React.ReactNode
}

const UserOnboardingMain = (props: Props) => {
  const {businessLogoUrl} = props.branding
  return (
    <MainSection>
      <Row>
        <Col xs={12}>
          <MainSectionImage src={businessLogoUrl} />
        </Col>
        <Col xs={12}>{props.children || null}</Col>
      </Row>
    </MainSection>
  )
}

export default withBranding(UserOnboardingMain)
